<template>
  <a-modal
    :visible="visible"
    width="702px"
    :mask-closable="false"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #qichacha_name>
        <a-input
          v-decorator="[
            'qichacha_name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入服务商名称',
                },
              ],
            },
          ]"
          placeholder="请输入服务商名称"
        />
      </template>
      <template #qichacha_oper_name>
        <a-input
          v-decorator="[
            'qichacha_oper_name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入联系人',
                },
              ],
            },
          ]"
          placeholder="请输入联系人"
        />
      </template>
      <template #phone>
        <a-input
          v-decorator="[
            'phone',
            {
              rules: [
                { required: true, message: '请输入手机号码' },
                {
                  pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                  message: '请输入正确的手机号码',
                },
              ],
            },
          ]"
          placeholder="请输入手机号码"
        />
      </template>
      <template #provinceCity>
        <province-city
          v-decorator="[
            'provinceCity',
            {
              rules: [{ required: false, validator: checkProvinceCity }],
            },
          ]"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import { formData } from '../data/index';
import ProvinceCity from './../../BusinessManage/components/ProvinceCity';
export default {
  components: {ProvinceCity},
  props: ['visible', 'title', 'btnIsLoading'],
  data() {
    return {
      formData,
      loading: false,
    };
  },
  async mounted() {
  },

  methods: {
    // 自定义省市校验
    checkProvinceCity(rule, value, callback) {
      const error = [];
      if (!value || !value.province) {
        error.push('省份');
      }
      // if (!value || !value.city) {
      //   error.push('城市');
      // }
      if (error.length === 0) {
        callback();
      }
      callback(`请选择${error.join('和')}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
